// extracted by mini-css-extract-plugin
export var growableInput = "_8e-0";
export var tagContainer = "_8e-2";
export var textInput = "_8e-1";